import type { ConversationLifecycleEvent } from './types';

export const lifecycleStatusText = (event: ConversationLifecycleEvent | null): string | null => {
  switch (event?.state) {
    case 'WAITING_REVIEW':
      return 'Needs recruiter review';
    case 'FAILED':
      return event.retryable ? 'Processing paused; retry is available' : 'Message processing stopped';
    case 'SUPERSEDED':
      return 'A newer message replaced this processing attempt';
    case 'RECONCILED':
      return 'Conversation state synchronized';
    case 'STEERING':
      return 'Choosing next step';
    case 'COMPOSING':
      return 'Writing reply';
    case 'RECEIVED':
    case 'QUEUED':
    case 'UNDERSTANDING':
    case 'VALIDATING':
    case 'PREPARING_REPLY':
    case 'SENDING':
      return 'Processing message';
    case 'SENT':
    default:
      return null;
  }
};
